import * as React from 'react'

export type FlagComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>
export type GlyphLoader = () => Promise<{ default: FlagComponent }>
type LazyFactory = (loader: GlyphLoader) => React.LazyExoticComponent<FlagComponent>

interface CreateGetGlyphComponentDependencies {
  loaders: Record<string, GlyphLoader | undefined>
  lazy: LazyFactory
  cache?: Map<string, React.LazyExoticComponent<FlagComponent>>
}

export function createGetGlyphComponent({
  loaders,
  lazy,
  cache = new Map<string, React.LazyExoticComponent<FlagComponent>>(),
}: CreateGetGlyphComponentDependencies) {
  return function getGlyphComponent(glyph: string): React.LazyExoticComponent<FlagComponent> | null {
    const name = glyph.replace(/^IconFlag/, '')
    const loader = loaders[name]

    if (!loader) {
      return null
    }

    if (!cache.has(name)) {
      cache.set(name, lazy(loader))
    }

    return cache.get(name)!
  }
}
